
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexdvYLMKHSgCh0YFvn3yvGLQNPhLIadbDYU0kPUJQ34fQMeta } from "/var/www/html/pages/index.vue?macro=true";
import { default as iconsD6oSiJCpix3rfTdmZOOS4GUuB8O0pdM0gAAAi22W1JgMeta } from "/var/www/html/pages/dev/icons.vue?macro=true";
import { default as signout8_w_45UqPxsNze91M7fL0h3dTToMq0j8mCfCa6aY_45N78wMeta } from "/var/www/html/pages/auth/signout.vue?macro=true";
import { default as archivdlb6PUj00n90do08TH3njuHJQirQKKNxkw52fba1oJEMeta } from "/var/www/html/pages/members/archiv.vue?macro=true";
import { default as profileOe2cWShs1nc5tL6Am5iJqJbSBO_45kcHhx_45rwkdZb_451i4Meta } from "/var/www/html/pages/members/profile.vue?macro=true";
import { default as calendarLFXqyjgpOdbKuhPvOtFhBp8YgDsztNBNa6P0s1eIgfMMeta } from "/var/www/html/pages/members/calendar.vue?macro=true";
import { default as dashboard7lL4_45eRrEPHqkd1aK3UXs5RY3OSy3bi7chCqhOZ_45Ez8Meta } from "/var/www/html/pages/members/dashboard.vue?macro=true";
import { default as documentsZl_mBVNyqoWRxz5TZfqAwq63WZPa5lFr1JG8lkJnII0Meta } from "/var/www/html/pages/members/documents.vue?macro=true";
import { default as updatingNQ5iZNfdqQPQ_45VXOetRZ_5E3luW4h5Z4o_45dRsXhlnkAMeta } from "/var/www/html/pages/maintenance/updating.vue?macro=true";
import { default as indexrZG_swIweuaSzcusybIbYeYoWUX_45e8u0I9JC7QIG564Meta } from "/var/www/html/pages/reset-password/index.vue?macro=true";
import { default as _91token_93LR6VCZr2gbwRA_vfyyCn6JIQuH9OngXLjfHNiDv5yKgMeta } from "/var/www/html/pages/activate-user/[token].vue?macro=true";
import { default as index3Q_45oPFvCjk_lLRcLP27rKesstfpBX4fHIYqebtKvQgEMeta } from "/var/www/html/pages/activation-code/index.vue?macro=true";
import { default as changeZAdIe4MI_453nORVkpE7dnru3hQfIJxJ2LQEYqm9tyDfAMeta } from "/var/www/html/pages/reset-password/change.vue?macro=true";
import { default as indexBpVo3dbLcaBWh72I6EuAT4578kfOGjcMe73Lcr9abY0Meta } from "/var/www/html/pages/members/discover/index.vue?macro=true";
import { default as _91token_93qZsrzL0xVQEb_Nyqef7o1gXMby_45INXefKKIl08NEJA8Meta } from "/var/www/html/pages/reset-password/[token].vue?macro=true";
import { default as _91token_93skljLE0zuH_45bmUn9h1B0CMXgD5w4_45uW9JrE0mTumW6oMeta } from "/var/www/html/pages/activation-code/[token].vue?macro=true";
import { default as by_45tokenPilSjqjmAQ1ZailPnwCRLciG25aAjj3iYDUI5wNj7aEMeta } from "/var/www/html/pages/reset-password/by-token.vue?macro=true";
import { default as _91topic_93yQt1tARymJRRCdofI31QBum5skJBUP_8FuDuOM4GCbYMeta } from "/var/www/html/pages/members/discover/[topic].vue?macro=true";
import { default as _91course_93jlRqxSpc2IS894ueld_VlGOdScbIQ_450yYUs_R8FEOnkMeta } from "/var/www/html/pages/members/elearning/[course].vue?macro=true";
import { default as indexPN2McoF1xVtLo9IR3Y4j9Nc8G_wDwFqyOvCsCS7rzscMeta } from "/var/www/html/pages/admin/[team]/[product]/index.vue?macro=true";
import { default as accountY1iTzKs1myMNosh4ntLDODy2jgYOJRIRW_45Sun_c_2iUMeta } from "/var/www/html/pages/admin/[team]/[product]/account.vue?macro=true";
import { default as upgradeZ_45LqQWRL2HeQNkBDNeokTOfHASCzioaiw4zwLX9py4kMeta } from "/var/www/html/pages/admin/[team]/[product]/upgrade.vue?macro=true";
import { default as dashboard8qrxX0TX_45tbU5boLr8Io589QyDMZ10y1HhJWTfGzKTsMeta } from "/var/www/html/pages/admin/[team]/[product]/dashboard.vue?macro=true";
import { default as migration30p7T6A3A9WmF7gSLSVE4ztEANC1P8m98qtxCAiMkhsMeta } from "/var/www/html/pages/admin/[team]/[product]/migration.vue?macro=true";
import { default as _91id_930_45yMjKzUhl1DfFmT9eq3Gh2h6jL_LtCruCdZP3_45jV_MMeta } from "/var/www/html/pages/admin/[team]/[product]/groups/[id].vue?macro=true";
import { default as _91id_93K0167xkex7hS74pmwmEl7OIVu_45uJP5zXbs3m8WzVHSQMeta } from "/var/www/html/pages/admin/[team]/[product]/import/[id].vue?macro=true";
import { default as indexnx7Dko95nhVRTqMg4ofDSLNUgXBQG4PUeIHoI8aj0YIMeta } from "/var/www/html/pages/members/learning-path/[path]/index.vue?macro=true";
import { default as indexMC36BKvagzhgRgikVcVZYxvyBUKMwpXl7zPTMd5IJoUMeta } from "/var/www/html/pages/members/participation/[slug]/index.vue?macro=true";
import { default as indexppRtNFAKinp5luniwdXAURpOpt3gx3cTvNkpH_45JfWVAMeta } from "/var/www/html/pages/admin/[team]/[product]/groups/index.vue?macro=true";
import { default as indexsfTDVWvwc7UiP21h_45P1xXqnJHQfyLAIgpZxxiTONedcMeta } from "/var/www/html/pages/admin/[team]/[product]/topics/index.vue?macro=true";
import { default as _91id_93d0THNl210D_45cgp1cjQgUTEqV_kPwASn3Genw3pwF6UgMeta } from "/var/www/html/pages/admin/[team]/[product]/employees/[id].vue?macro=true";
import { default as _91id_935dOJ5H1lR3JaSGs_45ewJh_uAYKFno8LKNRsmjlW11MKAMeta } from "/var/www/html/pages/admin/[team]/[product]/trainings/[id].vue?macro=true";
import { default as indexe_45P7Px3Nn2qcjLzJCNuYtL7F0CdpLr6O9unoILFG7UgMeta } from "/var/www/html/pages/admin/[team]/[product]/employees/index.vue?macro=true";
import { default as indexS1tGhjNpVHzME9QUveMpJqwIhl9E5ktrfs7ETCGpEQ8Meta } from "/var/www/html/pages/admin/[team]/[product]/trainings/index.vue?macro=true";
import { default as index5vel77Eh5abd_45CNZxoAWsKeoIdp4IY2m9m292OU1HzUMeta } from "/var/www/html/pages/members/learning/[course]/module/index.vue?macro=true";
import { default as indexAjUJzKBHssZXUvnOzx_45hdMeoY6vwHMD_6JDCiIOTdcEMeta } from "/var/www/html/pages/admin/[team]/[product]/topics/[id]/index.vue?macro=true";
import { default as indexXnnsM_45PJfi8K55sSQO_45cMU8DtJ5lAjs89VMMYz7KY9YMeta } from "/var/www/html/pages/admin/[team]/[product]/certificates/index.vue?macro=true";
import { default as _91id_93L98u4t1lMCcqxKDtFa7Sh4v6GJioZcOYglZXThck9KEMeta } from "/var/www/html/pages/admin/[team]/[product]/learning-path/[id].vue?macro=true";
import { default as _91id_93FMwY1B0Ys3vf5uTKlXX33NkOjyts0_2MiNzbr0mLZFMMeta } from "/var/www/html/pages/admin/[team]/[product]/topic-catalog/[id].vue?macro=true";
import { default as _91module_93O6DbkMgQ_45CEm8_45RSyCNuTSrS2bZYMECZmpKTxeYzhuIMeta } from "/var/www/html/pages/members/learning/[course]/module/[module].vue?macro=true";
import { default as index5Z0OnxvzU_45p05HDR__45biKIDDZRksMC4v_poe4x_45q4fEMeta } from "/var/www/html/pages/admin/[team]/[product]/employees/sap/index.vue?macro=true";
import { default as index0si8teb_45t6Jt5jjGKu7dgNwpvccM2aWvXm0LIg141MoMeta } from "/var/www/html/pages/admin/[team]/[product]/learning-path/index.vue?macro=true";
import { default as indexhnZSCz5r20EDOO7yh8IBUmOXk6kuPdbNYxyQnrg1laQMeta } from "/var/www/html/pages/admin/[team]/[product]/topic-catalog/index.vue?macro=true";
import { default as indexsvOdM7THilTWHs_45c0Whjo6ei59JszDjoAnteENi6lFwMeta } from "/var/www/html/pages/admin/[team]/[product]/certificate-archive/index.vue?macro=true";
import { default as _91course_93CjN9uk52yOLkimVtEjDaUQH0D1PICmq0bIKypudNX5EMeta } from "/var/www/html/pages/admin/[team]/[product]/topics/elearning/[course].vue?macro=true";
import { default as indexNNgBsTVysK8v5lREqzzbkHroTy5b_F76QijBUFyphacMeta } from "/var/www/html/pages/members/participation/[slug]/elearning/[course]/index.vue?macro=true";
import { default as _91foreignId_93tOUYAfVJICtiaxaUwmgS67j5n8DY1w7yaqgP_SWNpzwMeta } from "/var/www/html/pages/admin/[team]/[product]/topics/[id]/builder/[foreignId].vue?macro=true";
import { default as _91module_93v4u1k8M8BoXsMbSBmGWZid2d1d_dwtCwTng7R7PGjN4Meta } from "/var/www/html/pages/members/participation/[slug]/elearning/[course]/[module].vue?macro=true";
import { default as _91id_93PTtFXwV84PZuYsKhlHgi5qCMefAJxEFsm9lYPm9TUpYMeta } from "/var/www/html/pages/admin/[team]/[product]/learning-path/[learningPathId]/[id].vue?macro=true";
import { default as indexjEJ56GFw_4Q0bPW7mAdJWds3HyYw4YJFZAxvNm830WsMeta } from "/var/www/html/pages/members/participation/[slug]/elearning/scorm/[course]/index.vue?macro=true";
import { default as maintenance_7kS8Ip1N10rS9jXoMvQdMQ9R2mWLT9aofoYSCD9YVQMeta } from "/var/www/html/node_modules/@blumewas/nuxt-maintenance/dist/runtime/components/maintenance.vue?macro=true";
import { default as component_45stub1ieq9ngBAdHBgz_45spbP80jy_rDpu9r5e1KVm412_uaEMeta } from "/var/www/html/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub1ieq9ngBAdHBgz_45spbP80jy_rDpu9r5e1KVm412_uaE } from "/var/www/html/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexdvYLMKHSgCh0YFvn3yvGLQNPhLIadbDYU0kPUJQ34fQMeta || {},
    component: () => import("/var/www/html/pages/index.vue")
  },
  {
    name: "dev-icons",
    path: "/dev/icons",
    meta: { ...(iconsD6oSiJCpix3rfTdmZOOS4GUuB8O0pdM0gAAAi22W1JgMeta || {}), ...{"middleware":["dev-only"]} },
    component: () => import("/var/www/html/pages/dev/icons.vue")
  },
  {
    name: "auth-signout",
    path: "/auth/signout",
    component: () => import("/var/www/html/pages/auth/signout.vue")
  },
  {
    name: "members-archiv",
    path: "/members/archiv",
    meta: archivdlb6PUj00n90do08TH3njuHJQirQKKNxkw52fba1oJEMeta || {},
    component: () => import("/var/www/html/pages/members/archiv.vue")
  },
  {
    name: "members-profile",
    path: "/members/profile",
    meta: profileOe2cWShs1nc5tL6Am5iJqJbSBO_45kcHhx_45rwkdZb_451i4Meta || {},
    component: () => import("/var/www/html/pages/members/profile.vue")
  },
  {
    name: "members-calendar",
    path: "/members/calendar",
    meta: calendarLFXqyjgpOdbKuhPvOtFhBp8YgDsztNBNa6P0s1eIgfMMeta || {},
    component: () => import("/var/www/html/pages/members/calendar.vue")
  },
  {
    name: "members-dashboard",
    path: "/members/dashboard",
    meta: dashboard7lL4_45eRrEPHqkd1aK3UXs5RY3OSy3bi7chCqhOZ_45Ez8Meta || {},
    component: () => import("/var/www/html/pages/members/dashboard.vue")
  },
  {
    name: "members-documents",
    path: "/members/documents",
    meta: documentsZl_mBVNyqoWRxz5TZfqAwq63WZPa5lFr1JG8lkJnII0Meta || {},
    component: () => import("/var/www/html/pages/members/documents.vue")
  },
  {
    name: "maintenance-updating",
    path: "/maintenance/updating",
    component: () => import("/var/www/html/pages/maintenance/updating.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: indexrZG_swIweuaSzcusybIbYeYoWUX_45e8u0I9JC7QIG564Meta || {},
    component: () => import("/var/www/html/pages/reset-password/index.vue")
  },
  {
    name: "activate-user-token",
    path: "/activate-user/:token()",
    meta: _91token_93LR6VCZr2gbwRA_vfyyCn6JIQuH9OngXLjfHNiDv5yKgMeta || {},
    component: () => import("/var/www/html/pages/activate-user/[token].vue")
  },
  {
    name: "activation-code",
    path: "/activation-code",
    meta: index3Q_45oPFvCjk_lLRcLP27rKesstfpBX4fHIYqebtKvQgEMeta || {},
    component: () => import("/var/www/html/pages/activation-code/index.vue")
  },
  {
    name: "reset-password-change",
    path: "/reset-password/change",
    meta: changeZAdIe4MI_453nORVkpE7dnru3hQfIJxJ2LQEYqm9tyDfAMeta || {},
    component: () => import("/var/www/html/pages/reset-password/change.vue")
  },
  {
    name: "members-discover",
    path: "/members/discover",
    meta: indexBpVo3dbLcaBWh72I6EuAT4578kfOGjcMe73Lcr9abY0Meta || {},
    component: () => import("/var/www/html/pages/members/discover/index.vue")
  },
  {
    name: "reset-password-token",
    path: "/reset-password/:token()",
    meta: _91token_93qZsrzL0xVQEb_Nyqef7o1gXMby_45INXefKKIl08NEJA8Meta || {},
    component: () => import("/var/www/html/pages/reset-password/[token].vue")
  },
  {
    name: "activation-code-token",
    path: "/activation-code/:token()",
    meta: _91token_93skljLE0zuH_45bmUn9h1B0CMXgD5w4_45uW9JrE0mTumW6oMeta || {},
    component: () => import("/var/www/html/pages/activation-code/[token].vue")
  },
  {
    name: "reset-password-by-token",
    path: "/reset-password/by-token",
    meta: by_45tokenPilSjqjmAQ1ZailPnwCRLciG25aAjj3iYDUI5wNj7aEMeta || {},
    component: () => import("/var/www/html/pages/reset-password/by-token.vue")
  },
  {
    name: "members-discover-topic",
    path: "/members/discover/:topic()",
    meta: _91topic_93yQt1tARymJRRCdofI31QBum5skJBUP_8FuDuOM4GCbYMeta || {},
    component: () => import("/var/www/html/pages/members/discover/[topic].vue")
  },
  {
    name: "members-elearning-course",
    path: "/members/elearning/:course()",
    meta: _91course_93jlRqxSpc2IS894ueld_VlGOdScbIQ_450yYUs_R8FEOnkMeta || {},
    component: () => import("/var/www/html/pages/members/elearning/[course].vue")
  },
  {
    name: "admin-team-product",
    path: "/admin/:team()/:product()",
    meta: { ...(indexPN2McoF1xVtLo9IR3Y4j9Nc8G_wDwFqyOvCsCS7rzscMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/index.vue")
  },
  {
    name: "admin-team-product-account",
    path: "/admin/:team()/:product()/account",
    meta: accountY1iTzKs1myMNosh4ntLDODy2jgYOJRIRW_45Sun_c_2iUMeta || {},
    component: () => import("/var/www/html/pages/admin/[team]/[product]/account.vue")
  },
  {
    name: "admin-team-product-upgrade",
    path: "/admin/:team()/:product()/upgrade",
    props: {"hideActions":true},
    meta: upgradeZ_45LqQWRL2HeQNkBDNeokTOfHASCzioaiw4zwLX9py4kMeta || {},
    component: () => import("/var/www/html/pages/admin/[team]/[product]/upgrade.vue")
  },
  {
    name: "admin-team-product-dashboard",
    path: "/admin/:team()/:product()/dashboard",
    meta: { ...(dashboard8qrxX0TX_45tbU5boLr8Io589QyDMZ10y1HhJWTfGzKTsMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/dashboard.vue")
  },
  {
    name: "admin-team-product-migration",
    path: "/admin/:team()/:product()/migration",
    meta: migration30p7T6A3A9WmF7gSLSVE4ztEANC1P8m98qtxCAiMkhsMeta || {},
    component: () => import("/var/www/html/pages/admin/[team]/[product]/migration.vue")
  },
  {
    name: "admin-team-product-groups-id",
    path: "/admin/:team()/:product()/groups/:id()",
    meta: { ...(_91id_930_45yMjKzUhl1DfFmT9eq3Gh2h6jL_LtCruCdZP3_45jV_MMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/groups/[id].vue")
  },
  {
    name: "admin-team-product-import-id",
    path: "/admin/:team()/:product()/import/:id()",
    meta: { ...(_91id_93K0167xkex7hS74pmwmEl7OIVu_45uJP5zXbs3m8WzVHSQMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/import/[id].vue")
  },
  {
    name: "members-learning-path-path",
    path: "/members/learning-path/:path()",
    meta: indexnx7Dko95nhVRTqMg4ofDSLNUgXBQG4PUeIHoI8aj0YIMeta || {},
    component: () => import("/var/www/html/pages/members/learning-path/[path]/index.vue")
  },
  {
    name: "members-participation-slug",
    path: "/members/participation/:slug()",
    meta: indexMC36BKvagzhgRgikVcVZYxvyBUKMwpXl7zPTMd5IJoUMeta || {},
    component: () => import("/var/www/html/pages/members/participation/[slug]/index.vue")
  },
  {
    name: "admin-team-product-groups",
    path: "/admin/:team()/:product()/groups",
    meta: { ...(indexppRtNFAKinp5luniwdXAURpOpt3gx3cTvNkpH_45JfWVAMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/groups/index.vue")
  },
  {
    name: "admin-team-product-topics",
    path: "/admin/:team()/:product()/topics",
    meta: { ...(indexsfTDVWvwc7UiP21h_45P1xXqnJHQfyLAIgpZxxiTONedcMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/topics/index.vue")
  },
  {
    name: "admin-team-product-employees-id",
    path: "/admin/:team()/:product()/employees/:id()",
    meta: { ...(_91id_93d0THNl210D_45cgp1cjQgUTEqV_kPwASn3Genw3pwF6UgMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/employees/[id].vue")
  },
  {
    name: "admin-team-product-trainings-id",
    path: "/admin/:team()/:product()/trainings/:id()",
    meta: { ...(_91id_935dOJ5H1lR3JaSGs_45ewJh_uAYKFno8LKNRsmjlW11MKAMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/trainings/[id].vue")
  },
  {
    name: "admin-team-product-employees",
    path: "/admin/:team()/:product()/employees",
    meta: { ...(indexe_45P7Px3Nn2qcjLzJCNuYtL7F0CdpLr6O9unoILFG7UgMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/employees/index.vue")
  },
  {
    name: "admin-team-product-trainings",
    path: "/admin/:team()/:product()/trainings",
    meta: { ...(indexS1tGhjNpVHzME9QUveMpJqwIhl9E5ktrfs7ETCGpEQ8Meta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/trainings/index.vue")
  },
  {
    name: "members-learning-course-module",
    path: "/members/learning/:course()/module",
    meta: index5vel77Eh5abd_45CNZxoAWsKeoIdp4IY2m9m292OU1HzUMeta || {},
    component: () => import("/var/www/html/pages/members/learning/[course]/module/index.vue")
  },
  {
    name: "admin-team-product-topics-id",
    path: "/admin/:team()/:product()/topics/:id()",
    meta: { ...(indexAjUJzKBHssZXUvnOzx_45hdMeoY6vwHMD_6JDCiIOTdcEMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/topics/[id]/index.vue")
  },
  {
    name: "admin-team-product-certificates",
    path: "/admin/:team()/:product()/certificates",
    meta: { ...(indexXnnsM_45PJfi8K55sSQO_45cMU8DtJ5lAjs89VMMYz7KY9YMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/certificates/index.vue")
  },
  {
    name: "admin-team-product-learning-path-id",
    path: "/admin/:team()/:product()/learning-path/:id()",
    meta: { ...(_91id_93L98u4t1lMCcqxKDtFa7Sh4v6GJioZcOYglZXThck9KEMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/learning-path/[id].vue")
  },
  {
    name: "admin-team-product-topic-catalog-id",
    path: "/admin/:team()/:product()/topic-catalog/:id()",
    meta: { ...(_91id_93FMwY1B0Ys3vf5uTKlXX33NkOjyts0_2MiNzbr0mLZFMMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/topic-catalog/[id].vue")
  },
  {
    name: "members-learning-course-module-module",
    path: "/members/learning/:course()/module/:module()",
    meta: _91module_93O6DbkMgQ_45CEm8_45RSyCNuTSrS2bZYMECZmpKTxeYzhuIMeta || {},
    component: () => import("/var/www/html/pages/members/learning/[course]/module/[module].vue")
  },
  {
    name: "admin-team-product-employees-sap",
    path: "/admin/:team()/:product()/employees/sap",
    meta: { ...(index5Z0OnxvzU_45p05HDR__45biKIDDZRksMC4v_poe4x_45q4fEMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/employees/sap/index.vue")
  },
  {
    name: "admin-team-product-learning-path",
    path: "/admin/:team()/:product()/learning-path",
    meta: { ...(index0si8teb_45t6Jt5jjGKu7dgNwpvccM2aWvXm0LIg141MoMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/learning-path/index.vue")
  },
  {
    name: "admin-team-product-topic-catalog",
    path: "/admin/:team()/:product()/topic-catalog",
    meta: { ...(indexhnZSCz5r20EDOO7yh8IBUmOXk6kuPdbNYxyQnrg1laQMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/topic-catalog/index.vue")
  },
  {
    name: "admin-team-product-certificate-archive",
    path: "/admin/:team()/:product()/certificate-archive",
    meta: { ...(indexsvOdM7THilTWHs_45c0Whjo6ei59JszDjoAnteENi6lFwMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/certificate-archive/index.vue")
  },
  {
    name: "admin-team-product-topics-elearning-course",
    path: "/admin/:team()/:product()/topics/elearning/:course()",
    meta: _91course_93CjN9uk52yOLkimVtEjDaUQH0D1PICmq0bIKypudNX5EMeta || {},
    component: () => import("/var/www/html/pages/admin/[team]/[product]/topics/elearning/[course].vue")
  },
  {
    name: "members-participation-slug-elearning-course",
    path: "/members/participation/:slug()/elearning/:course()",
    meta: indexNNgBsTVysK8v5lREqzzbkHroTy5b_F76QijBUFyphacMeta || {},
    component: () => import("/var/www/html/pages/members/participation/[slug]/elearning/[course]/index.vue")
  },
  {
    name: "admin-team-product-topics-id-builder-foreignId",
    path: "/admin/:team()/:product()/topics/:id()/builder/:foreignId()",
    meta: { ...(_91foreignId_93tOUYAfVJICtiaxaUwmgS67j5n8DY1w7yaqgP_SWNpzwMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/topics/[id]/builder/[foreignId].vue")
  },
  {
    name: "members-participation-slug-elearning-course-module",
    path: "/members/participation/:slug()/elearning/:course()/:module()",
    meta: _91module_93v4u1k8M8BoXsMbSBmGWZid2d1d_dwtCwTng7R7PGjN4Meta || {},
    component: () => import("/var/www/html/pages/members/participation/[slug]/elearning/[course]/[module].vue")
  },
  {
    name: "admin-team-product-learning-path-learningPathId-id",
    path: "/admin/:team()/:product()/learning-path/:learningPathId()/:id()",
    meta: { ...(_91id_93PTtFXwV84PZuYsKhlHgi5qCMefAJxEFsm9lYPm9TUpYMeta || {}), ...{"middleware":["product-access"]} },
    component: () => import("/var/www/html/pages/admin/[team]/[product]/learning-path/[learningPathId]/[id].vue")
  },
  {
    name: "members-participation-slug-elearning-scorm-course",
    path: "/members/participation/:slug()/elearning/scorm/:course()",
    meta: indexjEJ56GFw_4Q0bPW7mAdJWds3HyYw4YJFZAxvNm830WsMeta || {},
    component: () => import("/var/www/html/pages/members/participation/[slug]/elearning/scorm/[course]/index.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/var/www/html/node_modules/@blumewas/nuxt-maintenance/dist/runtime/components/maintenance.vue")
  },
  {
    name: component_45stub1ieq9ngBAdHBgz_45spbP80jy_rDpu9r5e1KVm412_uaEMeta?.name,
    path: "/admin/:pathMatch(.*)/employees/imports/**",
    component: component_45stub1ieq9ngBAdHBgz_45spbP80jy_rDpu9r5e1KVm412_uaE
  }
]